export default __webpack_public_path__ + "static/55-8b443fee1760ef5fef7584b2e94b2df6.png";